module.exports = __webpack_public_path__ + "img/xi_banner.d7597bb5.png";